import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './styles/modify';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { translate } from 'react-i18next';
import DateTimeInput from '../common/datetime-input';

// Change to false, or utilise config -> IS_DEVELOPMENT to trigger
const FREE_TEXT_ENABLED = true;

class ModifyProduct extends React.Component {

  render() {
    const {
      t,
      batch,
      parentUuid,
      description,
      systemIdentifier,
      productId,
      productVersion,
      systemStatus,
      paidThrough,
      onParentUuid,
      onDescription,
      onSystemIdentifier,
      onProductVersion,
      onSystemStatus,
      onPaidThrough,
      versions,
      systemStatuses,
      customers,
      locations,
      disabled,
      onSave,
      onCancel,
      onPush,
      canSave,
      canPush,
      freeTextProductVersion,
      onToggleFreeTextProductVersion
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value: value || '',
      onChange: (event) => fn(event.target.value)
    });
    return (
      <div className={classes.container}>
        <div>
          <div>
            <FormGroup>
              <Label for="modify_location">{t('modify.locationLabel')}</Label>
              <Input
                type="select"
                name="modify_location"
                id="modify_location"
                disabled={disabled}
                {...getFieldProps(parentUuid, onParentUuid)}
              >
                <option value="" disabled>{t('modify.locationPlaceholder')}</option>
                <optgroup label={t('modify.locationOptionGroupLabel')}>
                  {
                    locations
                      .map(
                        ({ name, uuid }, index) => <option value={uuid} key={index}>{name}</option>
                      )
                  }
                </optgroup>
                <optgroup label={t('modify.customerOptionGroupLabel')}>
                  {
                    customers
                      .map(
                        ({ name, uuid }, index) => <option value={uuid} key={index}>{name}</option>
                      )
                  }
                </optgroup>
              </Input>
            </FormGroup>
          </div>
          {
            batch ? null : (
              <div>
                <FormGroup>
                  <Label for="modify_description">{t('modify.descriptionLabel')}</Label>
                  <Input
                    type="text"
                    name="modify_description"
                    id="modify_description"
                    placeholder={t('modify.descriptionPlaceholder')}
                    disabled={disabled}
                    {...getFieldProps(description, onDescription)}
                  />
                </FormGroup>
              </div>
            )
          }
          {
            batch ? null : (
              <div>
                <FormGroup>
                  <Label for="modify_systemIdentifier">{t('modify.systemIdentifierLabel')}<span className={classes.requiredIndicator}>*</span></Label>
                  <Input
                    type="text"
                    name="modify_systemIdentifier"
                    id="modify_systemIdentifier"
                    placeholder={t('modify.systemIdentifierPlaceholder')}
                    disabled={disabled}
                    {...getFieldProps(systemIdentifier, onSystemIdentifier)}
                  />
                </FormGroup>
              </div>
            )
          }
          <div>
            <FormGroup>
              {
                (onToggleFreeTextProductVersion && FREE_TEXT_ENABLED) ? (
                  <div className={classes.toggleLabel}>
                    <Label for="modify_productVersion">{t('modify.productVersionLabel')}<span
                      className={classes.requiredIndicator}>*</span></Label>
                    <Button
                      color="link"
                      size="sm"
                      disabled={disabled}
                      onClick={onToggleFreeTextProductVersion}
                    >
                      {t(`modify.freeText${freeTextProductVersion ? 'Disable' : 'Enable'}`)}
                    </Button>
                  </div>
                ) : (
                  <Label for="modify_productVersion">{t('modify.productVersionLabel')}<span
                    className={classes.requiredIndicator}>*</span></Label>
                )
              }
              {
                (onToggleFreeTextProductVersion && FREE_TEXT_ENABLED && freeTextProductVersion) ? (
                  <Input
                    type="text"
                    name="modify_productVersion"
                    id="modify_productVersion"
                    placeholder={t('modify.productVersionPlaceholder')}
                    disabled={disabled}
                    {...getFieldProps(productVersion, onProductVersion)}
                  />
                ) : (
                  <Input
                    type="select"
                    name="modify_productVersion"
                    id="modify_productVersion"
                    disabled={disabled}
                    {...getFieldProps(productVersion, onProductVersion)}
                  >
                    <option value="" disabled>{t('modify.productVersionPlaceholder')}</option>
                    {
                      (
                        batch ? (
                          Object.keys(versions)
                            .reduce((values, key) => values.concat(versions[key]), [])
                            .filter((value, index, array) => array.slice(0, index).indexOf(value) === -1)
                            .sort((a, b) => {
                              const splitA = a.split('.'),
                                splitB = b.split('.');
                              if (splitA[0] !== splitB[0]) {
                                return splitA[0] < splitB[0] ? 1 : -1;
                              }
                              if (splitA[1] !== splitB[1]) {
                                return splitA[1] < splitB[0] ? 1 : -1;
                              }
                              if (splitA[2] !== splitB[2]) {
                                return splitA[2] < splitB[2] ? 1 : -1;
                              }
                              return a < b ? -1 : 1;
                            })
                        ) : (versions[productId] || [])
                      )
                        .map(
                          (identifier, index) => <option value={identifier} key={index}>{identifier}</option>
                        )
                    }
                  </Input>
                )
              }
            </FormGroup>
          </div>
          {
            batch ? null : (
              <div>
                <FormGroup>
                  <Label for="modify_systemStatus">{t('modify.systemStatusLabel')}<span className={classes.requiredIndicator}>*</span></Label>
                  <Input
                    type="select"
                    name="modify_systemStatus"
                    id="modify_systemStatus"
                    disabled={disabled}
                    {...getFieldProps(systemStatus, onSystemStatus)}
                  >
                    <option value="" disabled>{t('modify.systemStatusPlaceholder')}</option>
                    {
                      systemStatuses
                        .map(
                          (name, index) => <option value={name} key={index}>{name}</option>
                        )
                    }
                  </Input>
                </FormGroup>
              </div>
            )
          }
          <div>
            <FormGroup>
              <Label for="modify_paidThrough">{t('modify.paidThroughLabel')}</Label>
              <DateTimeInput
                name="modify_paidThrough"
                id="modify_paidThrough"
                placeholder={t('modify.paidThroughPlaceholder')}
                disabled={disabled}
                value={paidThrough}
                onChangeValue={onPaidThrough}
              />
            </FormGroup>
          </div>
        </div>
        <div className={classes.actionsContainer}>
          <div className={classes.actionsInnerContainer}>
            <Button
              color="primary"
              size="sm"
              disabled={!canSave || disabled}
              onClick={onSave}
            >
              {t('modify.saveAction')}
            </Button>
            <Button
              color="danger"
              size="sm"
              disabled={disabled}
              onClick={onCancel}
            >
              {t('modify.cancelAction')}
            </Button>
          </div>
          <Button
            color="danger"
            size="sm"
            disabled={!canPush || disabled}
            onClick={onPush}
          >
            {t('modify.pushAction')}
          </Button>
        </div>
      </div>
    )
  }

}

ModifyProduct.propTypes = {
  batch: PropTypes.bool,
  parentUuid: PropTypes.string,
  description: PropTypes.string,
  systemIdentifier: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  productVersion: PropTypes.string,
  systemStatus: PropTypes.string,
  paidThrough: PropTypes.number,
  onParentUuid: PropTypes.func.isRequired,
  onDescription: PropTypes.func.isRequired,
  onSystemIdentifier: PropTypes.func.isRequired,
  onProductVersion: PropTypes.func.isRequired,
  onSystemStatus: PropTypes.func.isRequired,
  onPaidThrough: PropTypes.func.isRequired,
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  systemStatuses: PropTypes.arrayOf(
    PropTypes.string.isRequired
  ),
  // Map where the keys are the products, and the values are arrays of available versions
  versions: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPush: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired,
  canPush: PropTypes.bool.isRequired,
  freeTextProductVersion: PropTypes.bool,
  onToggleFreeTextProductVersion: PropTypes.func
};

export default translate(['productInstance'])(ModifyProduct);



// WEBPACK FOOTER //
// ./src/views/product-instance/modify.js